
/* ═══════════════════════════════════════════════════════
   KAJABI CONFIGURATION
   Replace the value below with Nathan's Kajabi form URL.
   See vanderlands_setup_guide.md for instructions.
   ═══════════════════════════════════════════════════════ */
const KAJABI_FORM_URL = 'https://vanderlands.mykajabi.com/api/v2/forms/2149595262/submissions';

const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const DAY_NAMES   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
let selectedSoil = 'Clay';
const vltParams = new URLSearchParams(window.location.search);
let guestName = vltParams.get('name') || vltParams.get('first_name') || '';

function setSoil(s) {
  selectedSoil = s;
  document.getElementById('btn-clay').classList.toggle('active', s === 'Clay');
  document.getElementById('btn-sand').classList.toggle('active', s === 'Sand');
}

function setStep(n) {
  [1,2,3].forEach(i => {
    document.getElementById('si-'+i).className = 'step'+(i<n?' done':i===n?' active':'');
    if (i<3) document.getElementById('sl-'+i).className = 'step-line'+(i<n?' done':'');
  });
}

async function submitGate() {
  const name  = document.getElementById('gate-name').value.trim();
  const email = document.getElementById('gate-email').value.trim();
  if (!name)  { document.getElementById('gate-name').focus();  return; }
  if (!email || !email.includes('@')) { document.getElementById('gate-email').focus(); return; }
  guestName = name;
  document.getElementById('unlock-label').style.display  = 'none';
  document.getElementById('unlock-spinner').style.display = 'block';

  // Fire-and-forget to Kajabi — never blocks the user
  if (KAJABI_FORM_URL && KAJABI_FORM_URL !== 'REPLACE_WITH_KAJABI_FORM_URL') {
    fetch(KAJABI_FORM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ first_name: name, email: email }),
      mode: 'no-cors'
    }).catch(function(e) { console.warn('Kajabi submit error:', e); });
  }

  // Always advance immediately after a brief spinner flash
  setTimeout(function() {
    document.getElementById('step-gate').style.display = 'none';
    document.getElementById('step-lawn').style.display = 'block';
    setStep(2);
    window.scrollTo(0,0);
  }, 350);
}

const PRODUCTS = [
  { key:'proturf',     name:'Proturf Hi N',             unit:'kg',  rate100:4,   group:'gran',   soilFilter:'both', divAfter:false },
  { key:'acelepryn',   name:'Acelepryn GR Option',      unit:'kg',  rate100:1.5, group:'gran',   soilFilter:'both', divAfter:true  },
  { key:'astro',       name:'Astro 120',                unit:'ml',  rate100:5,   group:'growth', soilFilter:'both', divAfter:false },
  { key:'largo',       name:'Largo',                    unit:'ml',  rate100:100, group:'growth', soilFilter:'both', divAfter:false },
  { key:'renaissance', name:'Renaissance',              unit:'ml',  rate100:100, group:'growth', soilFilter:'both', divAfter:false },
  { key:'ironmaid',    name:'Iron Maid',                unit:'ml',  rate100:200, group:'growth', soilFilter:'both', divAfter:false },
  { key:'protesyn',    name:'Protesyn',                 unit:'ml',  rate100:100, group:'growth', soilFilter:'both', divAfter:true  },
  { key:'seaweed',     name:'Sportsmaster WSF Seaweed', unit:'ml',  rate100:100, group:'soil',   soilFilter:'both', divAfter:false },
  { key:'propel',      name:'Propel',                   unit:'ml',  rate100:100, group:'soil',   soilFilter:'clay', divAfter:false },
  { key:'gypflo',      name:'Gyp-Flo',                  unit:'ml',  rate100:100, group:'soil',   soilFilter:'clay', divAfter:false },
  { key:'retainpro',   name:'Retain Pro',               unit:'ml',  rate100:100, group:'soil',   soilFilter:'sand', divAfter:false },
  { key:'spartan',     name:'Spartan',                  unit:'ml',  rate100:30,  group:'soil',   soilFilter:'both', divAfter:false },
];

const SCHEDULE = {
  36: { largo:1, renaissance:1, protesyn:1 },
  38: { acelepryn:1, seaweed:2, propel:1, gypflo:1, retainpro:1 },
  40: { proturf:1 },
  42: { seaweed:2, propel:1, gypflo:1, retainpro:1 },
  44: {},
  46: { seaweed:2, propel:1, gypflo:1, retainpro:1, spartan:1 },
  48: { proturf:0.5, astro:1, largo:1, renaissance:1 },
  50: { seaweed:2, propel:1, gypflo:1, retainpro:1 },
  52: { astro:2, largo:1, renaissance:1 },
  2:  { seaweed:2, propel:1, gypflo:1, retainpro:1 },
  4:  { astro:2, largo:1, renaissance:1 },
  6:  { proturf:0.5, seaweed:2, propel:1, gypflo:1, retainpro:1 },
  8:  { astro:2, largo:1, renaissance:1 },
  10: { acelepryn:1, seaweed:2, propel:1, gypflo:1, retainpro:1, spartan:1 },
  12: { astro:2, largo:1, renaissance:1 },
  14: { proturf:1, seaweed:2, propel:1, gypflo:1, retainpro:1 },
  16: { astro:1, largo:1, renaissance:1 },
  18: {},
  20: { largo:1, renaissance:1, protesyn:1 },
  22: {},
  24: { largo:1, renaissance:1, protesyn:1, spartan:1 },
  26: {},
  28: { largo:1, renaissance:1, protesyn:1 },
  30: {},
  32: { largo:1, renaissance:1, protesyn:1 },
  34: {},
};

function getEvenWeek(date) {
  const jan1 = new Date(date.getFullYear(),0,1);
  const week = Math.ceil(((date-jan1)/86400000+jan1.getDay()+1)/7);
  return week%2===0 ? week : week+1;
}
function fmtDate(d) {
  return DAY_NAMES[d.getDay()]+', '+d.getDate()+' '+MONTH_NAMES[d.getMonth()]+' '+d.getFullYear();
}
function calcAmt(key,mult,area,soil) {
  const p = PRODUCTS.find(x=>x.key===key);
  if (!p||!mult) return null;
  let r = p.rate100/100;
  if (key==='seaweed'&&soil==='Clay') r/=2;
  const v = mult*r*area;
  if (p.unit==='kg') {
    if (key==='acelepryn') return v.toFixed(1)+'kg\nor '+(v*10).toFixed(0)+'ml';
    return v.toFixed(1)+' kg';
  }
  return Math.round(v)+' ml';
}
function isApplicable(p,soil) {
  return p.soilFilter==='both'||p.soilFilter===soil.toLowerCase();
}

function generateSchedule() {
  const area  = parseFloat(document.getElementById('inp-area').value);
  const grass = document.getElementById('inp-grass').value||'Not specified';
  const soil  = selectedSoil;
  const startStr = document.getElementById('inp-start').value;
  if (!area||area<1) { alert('Please enter your lawn area in m²'); return; }
  if (!startStr)     { alert('Please select a start date'); return; }

  const namePill = document.getElementById('meta-name');
namePill.style.display = guestName ? 'inline-block' : 'none';
namePill.textContent = guestName;
  document.getElementById('meta-grass').textContent = grass;
  document.getElementById('meta-area').textContent  = area+' m²';
  const sp = document.getElementById('meta-soil');
  sp.textContent = soil+' soil';
  sp.className   = 'meta-pill'+(soil==='Sand'?' sand':'');

  const fortnights=[];
  let d=new Date(startStr);
  for(let i=0;i<26;i++){
    fortnights.push({date:new Date(d),week:getEvenWeek(d)});
    d.setDate(d.getDate()+14);
  }

  const table=document.getElementById('schedule-table');
  table.innerHTML='';

  const thead=document.createElement('thead');
  table.appendChild(thead);

  const groupRow=document.createElement('tr');
  groupRow.className='col-group-row';
  const thD=document.createElement('th');
  thD.className='th-date';thD.rowSpan=2;thD.textContent='Lawn Program';
  groupRow.appendChild(thD);
  // Always use full product count for colspan so headers span correctly
  const granColsAll  =PRODUCTS.filter(p=>p.group==='gran').length;
  const growthColsAll=PRODUCTS.filter(p=>p.group==='growth').length;
  const soilColsAll  =PRODUCTS.filter(p=>p.group==='soil').length;
  [['th-gran',granColsAll,'Granular Fertiliser – Insecticide Protection'],
   ['th-growth',growthColsAll,'Growth Regulator and Foliar Applications'],
   ['th-soil',soilColsAll,'Soil Amendments · Pre-emergents · Weeds']
  ].forEach(([cls,span,txt])=>{
    const th=document.createElement('th');
    th.className=cls;th.colSpan=span;
    th.innerHTML=cls==='th-soil'?'<em>'+txt+'</em>':txt;
    groupRow.appendChild(th);
  });
  thead.appendChild(groupRow);

  const prodRow=document.createElement('tr');
  prodRow.className='prod-header-row';
  PRODUCTS.forEach(p=>{
    const th=document.createElement('th');
    th.textContent=p.name;
    if(p.soilFilter==='clay') th.classList.add('th-clay');
    if(p.soilFilter==='sand') th.classList.add('th-sand');
    if(p.divAfter) th.style.borderRight='2px solid #333';
    prodRow.appendChild(th);
  });
  thead.appendChild(prodRow);

  const tbody=document.createElement('tbody');
  const totals={};
  PRODUCTS.forEach(p=>totals[p.key]=0);

  fortnights.forEach(({date,week})=>{
    const sched=SCHEDULE[week]||{};
    const tr=document.createElement('tr');
    const tdDate=document.createElement('td');
    tdDate.className='date-cell';
    tdDate.textContent=fmtDate(date);
    tr.appendChild(tdDate);
    PRODUCTS.forEach(p=>{
      const td=document.createElement('td');
      const ok=isApplicable(p,soil);
      const mult=sched[p.key]??null;
      if(!ok){
        td.className='prod-cell na-cell';
        td.title=p.soilFilter==='clay'?'Clay soil only':'Sand soil only';
      } else if(mult!==null){
        td.className='prod-cell has-product';
        if(p.soilFilter==='clay') td.style.background='#2d7a1a';
        if(p.soilFilter==='sand') td.style.background='#6a8e1a';
        td.textContent=calcAmt(p.key,mult,area,soil);
        let r=p.rate100/100;
        if(p.key==='seaweed'&&soil==='Clay') r/=2;
        totals[p.key]+=mult*r*area;
      } else {
        td.className='prod-cell empty';
      }
      if(p.divAfter) td.style.borderRight='2px solid #444';
      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });

  const totalRow=document.createElement('tr');
  totalRow.className='totals-row';
  const tdLbl=document.createElement('td');
  tdLbl.className='date-cell';tdLbl.textContent='Annual total';
  totalRow.appendChild(tdLbl);
  PRODUCTS.forEach(p=>{
    const td=document.createElement('td');
    if(!isApplicable(p,soil)){td.textContent='—';td.style.opacity='0.35';}
    else {
      const t=totals[p.key];
      td.textContent=t>0?(p.unit==='kg'?t.toFixed(1)+' kg':Math.round(t)+' ml'):'—';
    }
    if(p.divAfter) td.style.borderRight='2px solid #1a3010';
    totalRow.appendChild(td);
  });
  tbody.appendChild(totalRow);
  table.appendChild(tbody);

  document.getElementById('step-lawn').style.display='none';
  document.getElementById('step-output').style.display='block';
  setStep(3);
  window.scrollTo(0,0);
}

function goBack(){
  document.getElementById('step-output').style.display='none';
  document.getElementById('step-lawn').style.display='block';
  setStep(2);
  window.scrollTo(0,0);
}

document.getElementById('inp-start').value=new Date().toISOString().split('T')[0];

const gateEmail = document.getElementById('gate-email');
if (gateEmail) {
  gateEmail.addEventListener('keydown', e => {
    if (e.key === 'Enter') submitGate();
  });
}

// Shopify version: Kajabi captures the email first, then redirects here.
// So we skip the email gate and show the lawn details step immediately.
document.getElementById('step-gate').style.display = 'none';
document.getElementById('step-lawn').style.display = 'block';
setStep(2);